import cn from 'classnames';
import { useState } from 'react';
import { useSelector } from 'react-redux';

import { deviceSelector } from '../../entities/UserSlice';
import SVGelem from '../../shared/SVGelem/SVGelem';
import style from './ButtonSend.module.scss';

const ButtonSend = ({ className, handleFunction, iconStyle, page, testId }) => {
  const [iconHover, setIconHover] = useState(false);
  const device = useSelector(deviceSelector);

  return (
    <button
      className={page === 'visual' ? className : cn(style.buttonSend, className)}
      onClick={handleFunction}
      type='submit'
      onMouseOver={() => {
        if (device !== 'isMobile') {
          setIconHover(true);
        } else return;
      }}
      onMouseOut={() => {
        if (device !== 'isMobile') {
          setIconHover(false);
        } else return;
      }}
      aria-label='отправить'
      onFocus={() => {}}
      onBlur={() => {}}
      data-testid={testId ? testId : 'formSend'}
    >
      {!iconHover && page !== 'visual' && <SVGelem href='#arrow-small-black' className={style.buttonSendIcon} />}
      {iconHover && page !== 'visual' && <SVGelem href='#arrow-small-white' className={style.buttonSendIcon} />}

      {!iconHover && page === 'visual' && <SVGelem href='#arrow-small-white' className={iconStyle} />}
      {iconHover && page === 'visual' && <SVGelem href='#arrow-small-black' className={iconStyle} />}
    </button>
  );
};

export default ButtonSend;
